export const classes = {
  meetingDate: 'font-bold',
  content: 'mb-8',
};

export const LINKS = {
  meetingLink:
    'https://www.tijd.be/financiele-berichten/bijeenroepingen/condor-technologies-nv-gewone-algemene-vergadering/10224185.html',
};
